import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { isUndefined } from 'lodash'
import moment from 'moment'

const TODAY_DD_MMMM = moment().format('DD MMMM YYYY')
let createdBuff = undefined

export const MeetsStartAtDateChip = ({ startAt, startAtLast }) => {
    const start_DD_MMMM = moment(startAt).format('DD MMMM YYYY')
    const start_last_DD_MMMM = moment(startAtLast).format('DD MMMM YYYY')

    if (isUndefined(startAtLast)) {
        createdBuff = start_DD_MMMM === TODAY_DD_MMMM ? 'Сегодня' : start_DD_MMMM
    } else {
        if (start_DD_MMMM === start_last_DD_MMMM) {
            createdBuff = null
        } else {
            createdBuff = start_DD_MMMM === TODAY_DD_MMMM ? 'Сегодня' : start_DD_MMMM
        }
    }

    return (
        <>
            {createdBuff && (
                <Grid textAlign="center" container display="flex" sx={{ marginTop: '24px' }}>
                    <Typography variant="caption2" component="p" sx={{ color: '#5A5F72' }}>
                        {createdBuff === 'Сегодня'
                            ? 'Сегодня'
                            : moment(createdBuff, 'DD MMMM YYYY').format('DD MMMM YYYY')}
                    </Typography>

                    {/*<Chip*/}
                    {/*    label=*/}
                    {/*    variant="outlined"*/}
                    {/*    sx={{*/}
                    {/*        margin: '0 auto',*/}
                    {/*        fontSize: '12px',*/}
                    {/*        height: '24px',*/}
                    {/*        padding: '8px 12px',*/}
                    {/*        borderColor: '#E7E8EE',*/}
                    {/*        color: '#5E626E',*/}
                    {/*    }}*/}
                    {/*/>{' '}*/}
                </Grid>
            )}
        </>
    )
}
